'use client';

import { usePathname } from 'next/navigation';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';

// ポップアップページかどうかを判定するパス
const POPUP_PATHS = ['/regulation-check/', '/fact-check/'];

interface LayoutContentProps {
  children: React.ReactNode;
  pathname?: string; // サーバーから渡されるパス（フォールバック用）
}

export function LayoutContent({ children, pathname: serverPathname }: LayoutContentProps) {
  // クライアント側でパスを取得（より正確）
  const clientPathname = usePathname();
  const pathname = clientPathname || serverPathname || '';

  // ポップアップページかどうかを判定
  const isPopup = POPUP_PATHS.some(path => pathname.includes(path));

  if (isPopup) {
    // ポップアップページ: ヘッダー・フッターなし
    return (
      <div className="min-h-screen">
        <main>{children}</main>
      </div>
    );
  }

  // 通常ページ: ヘッダー・フッターあり
  return (
    <div className="flex flex-col min-h-screen relative">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
}
